import Swal from 'sweetalert2/dist/sweetalert2.js';
export const customSwal = Swal.mixin({
	customClass: {
		cancelButton: 'sa2-cancel-btn',
		confirmButton: 'sa2-confirm-btn'
	},
	buttonsStyling: false
});